import React from "react";

import backIcon from "../assets/icons/back.svg";

const PageTitle = ({ title, selectors, showBack }) => {

  const returnToPreviousPage = () => {
    window.history.back();
  }

  return (
    <div className={`page-title ${selectors ? "selectors" : null}`}>
      {showBack ? (
        <button className="back-btn" onClick={returnToPreviousPage}>
          <img src={backIcon} />
        </button>
      ) : null}
      {selectors}
      <span className="title">{title}</span>
    </div>
  );
}

export default PageTitle;
